// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const PdfIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'pdf'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.23223 2.39889C3.70107 1.93005 4.33696 1.66666 5 1.66666H12.5C12.721 1.66666 12.933 1.75445 13.0893 1.91073L17.2559 6.0774C17.4122 6.23368 17.5 6.44564 17.5 6.66666V10.8333H2.5V4.16666C2.5 3.50362 2.76339 2.86773 3.23223 2.39889ZM11.6667 5.83332C11.6667 6.27535 11.8423 6.69927 12.1548 7.01183C12.4674 7.3244 12.8913 7.49999 13.3333 7.49999H16.6667L11.6667 2.49999V5.83332Z"
          fill="currentColor"
        />
        <path
          d="M14.7931 12.5V18.3333H13.5438V12.5H14.7931ZM17.2085 14.992V15.9295H14.4517V14.992H17.2085ZM17.5 12.5V13.4415H14.4517V12.5H17.5Z"
          fill="currentColor"
        />
        <path
          d="M9.85843 18.3333H8.53833L8.54666 17.3958H9.85843C10.186 17.3958 10.4623 17.325 10.6871 17.1835C10.912 17.0393 11.0814 16.8296 11.1952 16.5545C11.3118 16.2794 11.3701 15.9468 11.3701 15.5569V15.2724C11.3701 14.9733 11.3368 14.7102 11.2701 14.4832C11.2063 14.2561 11.1105 14.0652 10.9828 13.9102C10.8551 13.7553 10.6982 13.6391 10.5122 13.5617C10.3262 13.4816 10.1125 13.4415 9.87092 13.4415H8.51335V12.5H9.87092C10.2763 12.5 10.6469 12.5668 10.9828 12.7003C11.3215 12.8312 11.6144 13.0195 11.8615 13.2652C12.1086 13.5109 12.2987 13.8047 12.432 14.1466C12.568 14.4858 12.636 14.8638 12.636 15.2804V15.5569C12.636 15.9709 12.568 16.3488 12.432 16.6907C12.2987 17.0326 12.1086 17.3264 11.8615 17.5721C11.6172 17.8152 11.3243 18.0035 10.9828 18.137C10.6441 18.2679 10.2693 18.3333 9.85843 18.3333ZM9.24627 12.5V18.3333H7.99697V12.5H9.24627Z"
          fill="currentColor"
        />
        <path
          d="M4.86118 16.254H3.31621V15.3165H4.86118C5.09994 15.3165 5.29427 15.2791 5.44419 15.2043C5.59411 15.1269 5.70377 15.02 5.77317 14.8838C5.84258 14.7476 5.87728 14.594 5.87728 14.4231C5.87728 14.2495 5.84258 14.0879 5.77317 13.9383C5.70377 13.7887 5.59411 13.6685 5.44419 13.5777C5.29427 13.4869 5.09994 13.4415 4.86118 13.4415H3.7493V18.3333H2.5V12.5H4.86118C5.33592 12.5 5.74264 12.5828 6.08134 12.7484C6.42281 12.9113 6.68378 13.137 6.86423 13.4255C7.04469 13.7139 7.13491 14.0438 7.13491 14.4151C7.13491 14.7917 7.04469 15.1175 6.86423 15.3926C6.68378 15.6677 6.42281 15.8801 6.08134 16.0296C5.74264 16.1792 5.33592 16.254 4.86118 16.254Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
PdfIcon.displayName = 'PdfIcon'
export { PdfIcon }
